/**
 * Custom (Universal), `/postbacks/custom`. All four surfaces — backoffice, TMA,
 * Telegram, and POSTBACK_LINKS_REFERENCE.md — agree verbatim on REG and CPA.
 * None of the four define an FTD or REDEP template for Custom.
 */
export const customContract = {
    id: 'custom',
    displayName: 'Custom (Universal)',
    route: 'custom',
    trackingTagMacro: '{clickid}',
    amountBehavior: 'amount comes from {payout} on CPA. currency is not sent; no fixed value is hardcoded either.',
    duplicateParamPolicy: 'array-then-tolerant-last-wins',
    caseSensitiveParams: [],
    pitfalls: [
        'Custom also accepts alternate parameter names via server-side fallback priority: subid direct > ' +
            'campaign_id > mid > trackingcode; uid direct > player_id > customerid > afp; tracking_tag explicit > ' +
            'clickid > clickId > afp > visit_id. This contract encodes only the primary/recommended macro names.',
        'sub2..sub5 are optional extra analytics slots and may be removed from the URL if unused.',
    ],
    sourceRefs: [
        'apps/api/src/modules/postbacks/controllers/postbacks.controller.ts:421-463',
        'apps/api/src/modules/postbacks/services/parameter-mapper.service.ts:173-206 (mapCustom)',
    ],
    events: [
        {
            event: 'REG',
            eventValue: 'registration',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{subid}' },
                { ourParam: 'sub2', macro: '{subid2}' },
                { ourParam: 'sub3', macro: '{subid3}' },
                { ourParam: 'sub4', macro: '{subid4}' },
                { ourParam: 'sub5', macro: '{subid5}' },
                { ourParam: 'tracking_tag', macro: '{clickid}' },
            ],
        },
        {
            event: 'QUALIFIED_CPA',
            eventValue: 'cpa',
            params: [
                { ourParam: 'uid', macro: '{clickid}' },
                { ourParam: 'subid', macro: '{subid}' },
                { ourParam: 'sub2', macro: '{subid2}' },
                { ourParam: 'sub3', macro: '{subid3}' },
                { ourParam: 'sub4', macro: '{subid4}' },
                { ourParam: 'sub5', macro: '{subid5}' },
                { ourParam: 'amount', macro: '{payout}' },
                { ourParam: 'tracking_tag', macro: '{clickid}' },
            ],
        },
    ],
};
//# sourceMappingURL=custom.js.map